// src/api_scripts/createSkill.js
import { createApiClient } from "../apiClient";

const createSkill = async (skillData, orgId, accessToken, setProgress) => {
  const { name } = skillData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Skill: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);
  
  // API endpoint for creating a new Skill
  const relativeUri = `organization/${orgId}/skill`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, skillData);

    const newSkill = response.data; // The API returns the created resource directly

    console.log("Create Skill API Response Data:", newSkill);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Skill "${name}" (ID: ${newSkill.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newSkill.id; // Return the created Skill object (includes its ID)

  } catch (error) {
    console.error(`Error creating Skill "${name}":`, error);

    let errorMessage = `Error creating Skill "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createSkill;
